export default "__VITE_ASSET__BwazHrcf__"